export enum IndeedEmployeesCount {
    'EMPLOYEE_1_49' = '1 to 49',
    'EMPLOYEE_50_149' = '50 to 149',
    'EMPLOYEE_150_249' = '150 to 249',
    'EMPLOYEE_250_499' = '250 to 499',
    'EMPLOYEE_500_749' = '500 to 749',
    'EMPLOYEE_750_999' = '750 to 999',
    'EMPLOYEE_1000_MORE' = '1000 to More',
}
